import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import router from '@/router'
// eslint-disable-next-line no-unused-vars
import WL from '@landscape/wordlab';
import { version } from "../../package.json";


const config = require('../credentials/ENV/prod');
const fb = require('../config/firebaseConfig');


Vue.use(Vuex);


var baseURL = config.API.base_url;
if (process.env.NODE_ENV === "development") {
  baseURL = config.API.base_url_locale;
}


const API = Axios.create({
  baseURL: baseURL, // SO :  swicth to '../credentials/ENV/prod' for local debug
  timeout: 10000,
  headers: {
    'Accept-Language': 'fr-FR' // TODO switch User accept langages ESP belgium NL FR ...
  }
});

API.interceptors.request.use(function (conf) {
  store.state.isLoading = true;
  return conf;
}, function (error) {
  store.state.isLoading = true;
  return Promise.reject(error);
});

API.interceptors.response.use(function (response) {
  store.state.isLoading = false;
  return response;
}, function (error) {
  store.state.isLoading = false;
  return Promise.reject(error);
});



fb.auth.onAuthStateChanged(async user => {
  if (user) {
    store.commit('setCurrentUser', user);
    // await store.dispatch('getAccess ', user);
    await store.dispatch('fetchUserProfile');
    await store.dispatch('fetchRules');
  }
});



var alreadySet = false;
var listenToUser = function () {
  if (!alreadySet && typeof store.state.userProfile !== "undefined" && store.state.userProfile) {
    alreadySet = true;
  }
}

import { Konami } from "@/helpers/konami";

export const store = new Vuex.Store({
  state: {
    offsetTop: 0,
    articles: [],
    history: [],
    react: null,
    userProfile: null,
    base_api_url: baseURL,
    DB: null,
    documentation: null,
    search: null,
    SearchResult: null,
    currentArticle: null,
    userMessages: null,
    konamiChecker: null,
    status: "",
    WordLabOutput: false,
    forceReload: false,
    menu: false,
    loginDialog: false,
    konami: false,
    isLoading: false,
    isLoader: false,
    fb: fb,
    notificationToken: "",
    API: API
  },
  mutations: {
    setMenu(state) {
      state.menu = !state.menu;
    },
    setKonami(state) {
      state.konami = !state.konami;
    },
    offsetTop(state, value) {
      state.offsetTop = value;
    },
    setCurrentUser(state, val) {
      document.cookie = `currentUser=${JSON.stringify(val)}`;
      state.currentUser = val
    },
    setUserProfile(state, val) {
      state.userProfile = val
    },
    upateUserProfile(state, val) {
      state.userProfile = val;
      store.dispatch('updateUserProfile');
    },
    setDoc(state, val) {
      state.documentation = val;
    },
    setScope(state, value) {
      if (state.userProfile.scopes.indexOf(value) !== -1)
        state.userProfile.scopes = state.userProfile.scopes.filter(entry => entry !== value)
      else
        state.userProfile.scopes.push(value)
    },
    setProp(state, payload) {
      document.cookie = `${payload.prop}=${payload.value}`;
      state[payload.prop] = payload.value;
    },
    postArticle(state, data) {
      state.newArticle = data;
      store.dispatch('postArticle');
    },
    patchArticle(state, data) {
      state.newArticle = data;
      store.dispatch('patchArticle');
    },
    deleteArticle() {
      store.dispatch('deleteArticle');
    },
    searchArticles(state, search) {
      state.search = search;
      store.dispatch('searchArticles');
    },
    react(state, value) {
      state.react = value;
      store.dispatch('postReact');
    },
    comment(state, value) {
      state.comment = value;
      store.dispatch('postComment');
    },
    commentEdit(state, value) {
      state.comment = value;
      store.dispatch('editComment');
    },
    commentDelete(state, value) {
      state.comment = value;
      store.dispatch('deleteComment');
    },
    setHistory(state, from) {
      if (state.history.length > 0 && state.history[state.history.length - 1].path === from.Path) {
        state.history[state.history.length - 1].hash = from.hash
      } else {
        state.history.push(from);
      }
      store.dispatch('setHistory');
    },
    showLoader(state) {
      state.isLoader = true;
      return state;
    },
    hideLoader(state) {
      state.isLoader = false;
      return state;
    },
    // eslint-disable-next-line no-unused-vars
    WordLabOutput(state, WordLabOutput) {
      Vue.set(state, 'WordLabOutput', true);
    },
    SearchResult(state, value) {
      Vue.set(state, 'SearchResult', value);
    }
  },
  getters: {
    menu: (state) => {
      return state.menu;
    },
    history: (state) => {
      return state.history;
    }
  },
  actions: {
    clearData({ commit }) {
      commit('unsetState', "currentUser", null)
      commit('unsetState', "userProfile", {})
      commit('unsetState', "scopes", null)
      commit('unsetState', "access", null)
    },
    async serverStatus({ state }) {
      let status = await API.get('/status');
      state.status = status.data.status;
    },
    async getDocs({ state }) {
      if (state.doc) {
        return state.doc;
      } else {
        let docs = await API.get('/documentation');
        store.commit('setDoc', docs.data);
        return docs.data;
      }
    },
    async fetchRules() {
      // getParams
      let params = await API.get(`/gamifier/getParams`, {});
      store.commit("setProp", {
        prop: "gamificationRules",
        value: params.data.params
      });
    },
    async fetchUserProfile({ state }) {
      // TODO IMPROVE LOCAL STORAGE WHEN GAMIFICATION UPDATED...
      /* if (getCookie('userProfile') && getCookie('userProfile') !== "undefined") {
        store.commit('setUserProfile', JSON.parse(getCookie('userProfile')));
      } else { */
      if (!state.currentUser)
        return false;
      let user = await API.get(`/users/${state.currentUser.uid}`, {});
      if (user && user.data.data.length > 0 && user.data.data[0] !== null) {
        document.cookie = `userProfile=${JSON.stringify(user.data.data[0])}`;
        store.commit('setUserProfile', user.data.data[0]);
        listenToUser();
        //state.userProfile = user.data.data[0];
      } else {
        store.dispatch('setUserProfile');
      }
      // }
    },
    async setUserProfile({ state }) {
      await API.post('/users', {
        id: state.currentUser.uid,
        email: state.currentUser.email,
        displayName: (state.currentUser.displayName) ? state.currentUser.displayName : state.currentUser.email,
        photoURL: (state.currentUser.photoURL) ? state.currentUser.photoURL : "no-pix"
      });
      store.dispatch('getAccess');

      store.dispatch('fetchUserProfile');
    },
    async updateUserProfile({ state }) {
      await API.patch('/users', state.userProfile);
      document.cookie = `userProfile=${JSON.stringify(state.userProfile)}`;
      await API.post('/gamifier', { gamifier: { type: "profile", value: "test" } });
      store.dispatch('fetchUserProfile');
    },
    // eslint-disable-next-line no-unused-vars
    async readArticle({ state }) {
      if (state.userProfile) {
        await API.post('/gamifier', { gamifier: { type: "read", value: state.currentArticle.id } });
        store.dispatch('fetchUserProfile');
      }
    },
    async getAccess({ state }) {
      if (!state.currentUser && getCookie('currentUser'))
        state.currentUser = JSON.parse(getCookie('currentUser'));

      if (state.currentUser && state.currentUser.uid) {
        let access = await API.get('/access', {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": config.FIREBASE.apiKey
          },
          params: {
            uuid: state.currentUser.uid,
            serial: null
          }
        });
        document.cookie = `authorization=${access.data.authorization}`
        API.defaults.headers.common['authorization'] = access.data.authorization;
        state.access = access.data.authorization;
        store.dispatch('setAccess');
      }
      return state;
    },
    async postArticle({ state }) {
      await API.post('/articles', state.newArticle);
      store.state.forceReload = true;
      store.dispatch('setArticles');
    },
    async postReact({ state }) {
      store.dispatch('getAccess');
      await API.post(`/articles/${state.react.id}/react/`, state.react);
      await API.post('/gamifier', { gamifier: { type: "react", value: state.currentArticle.id } });
    },
    async postComment({ state }) {
      await API.post(`/comments/${state.comment.id}/`, state.comment);
      await API.post('/gamifier', { gamifier: { type: "comment", value: state.currentArticle.id } });
    },
    async editComment({ state }) {
      await API.patch(`/comments/${state.comment.articleID}/${state.comment.id}/`, state.comment);
    },
    async deleteComment({ state }) {
      await API.delete(`/comments/${state.comment.articleID}/${state.comment.id}/`, state.comment);
    },
    async patchArticle({ state }) {
      await API.patch(`/articles/${router.currentRoute.params.id}`, state.newArticle);
      store.state.forceReload = true;
      store.dispatch('setArticles');
    },
    async deleteArticle() {
      await API.delete(`/articles/${router.currentRoute.params.id}`);
      store.state.forceReload = true;
      store.dispatch('setArticles');
      router.push("/");
    },

    setAccess({ state }) {
      if (!getCookie('authorization') || getCookie('authorization') === "") {
        store.dispatch('getAccess');
      } else {
        API.defaults.headers.common['authorization'] = getCookie('authorization');
        state.access = getCookie('authorization');
      }
      let cookies = document.cookie.split(';');
      for (let cooks of cookies) {
        let cooker = cooks.split('=');
        if (cooker[0].indexOf('_') === -1 && cooker[0].indexOf('gamificationRules') === -1) {
          try {
            this.state[cooker[0].replace(/\s/g, '')] = JSON.parse(cooker[1]);
          } catch (err) {
            this.state[cooker[0].replace(/\s/g, '')] = cooker[1];
          }
        }
      }
      /* if (typeof Notification !== "undefined" && Notification.permission === 'granted') {
        try {
          fb.messaging
            .requestPermission()
            .then(() => {
              try {
                fb.messaging.getToken().then(token => {
                  store.commit("setProp", {
                    prop: "notificationToken",
                    value: token
                  });
                  store.dispatch("registerNotifications");
                });
              } catch (err) {
                console.log('fb messaging  error', err);
              }
            })
            .catch(err => {
              console.log("Unable to get permission to notify.", err);
            });

          fb.messaging.onMessage(function (payload) {
            console.log(
              "Message received  ============================> . ",
              payload
            );
            // ...
          });
        } catch (err) {
          console.log('messaging error', err);
        }
      } */
      return state;
    },
    async setArticles({ state }) {
      let articles = await API.get('/articles', { params: { force: state.forceReload } });
      state.articles = articles.data.data;
      store.state.forceReload = false;
      setTimeout(function () { store.dispatch('setWordLab'); }, 300);
      return state;
    },

    async searchArticles({ state }) {
      if (!state.DB) return [];
      let ordered = await state.DB.search(state.search);
      let articlesFiltered = [];
      store.commit('SearchResult', ordered);
      ordered.result.forEach(entry => {
        state.articles.forEach(item => {
          if (item.id === entry.label)
            articlesFiltered.push(item);
        });
      });

      articlesFiltered.forEach(item => {
        item.score = 0;
        if (JSON.stringify(item).toLowerCase().indexOf(state.search.toLowerCase()) !== -1) {
          item.score += 100;
        }
        state.search.split(' ').forEach(word => {
          if (word.length > 2) {
            if (JSON.stringify(item).toLowerCase().match(new RegExp(word.toLowerCase(), 'g')))
              item.score += JSON.stringify(item).toLowerCase().match(new RegExp(word.toLowerCase(), 'g')).length;
          }
        });
      });

      articlesFiltered = articlesFiltered.sort((a, b) => {
        return b.score - a.score;
      });

      state.articles = articlesFiltered;
      return state;
    },
    async setWordLab({ state }) {
      state.DB = new WL.WordLab(
        state.articles,
        {
          scale: 400,
          keywords: ["short_description", "intro", "label", "category"],
          layers: {
            category: "category"
          },
          index: "category",
          key_index: "id",
          clean: true
        },
        function (e, val) {
          if (e.error)
            console.error(e, val);
          if (e.warn)
            console.warn(e, val);
        }.bind(this)
      );
      await state.DB.train();

      setTimeout(function () {
        store.commit('WordLabOutput', state.DB.output);
      }.bind(this), 1000);
      return state;
    },
    setHistory({ state }) {
      return state;
    },
    async registerNotifications({ state }) {
      await API.post('/notifications', { token: state.notificationToken });
    },
    getNotificationToken() {

    }
  },
  modules: {
  }
});

export const requestSignInLink = async ({ commit }, { email }) => {
  commit('setSignInEmail', email)
  await sendSignInLink(email)
}
export const sendSignInLink = email => {
  const actionCodeSettings = {
    url: `${location.origin}/signin/email`,
    handleCodeInApp: true
  }
  return fb.auth.sendSignInLinkToEmail(email, actionCodeSettings)
}
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

store.dispatch('setAccess');
store.dispatch('setArticles');

store.state.konamiChecker = new Konami("konami");
store.state.konamiChecker.subscribe(checking);

function checking(e) {
  if (e.status === 200) {
    store.commit('setKonami');
  }
}


// ANALYTICS SETUP

function isPWA() {
  return window && window.matchMedia("(display-mode: standalone)").matches;
}

router.beforeEach((to, from, next) => {
  fb.firebase.analytics().logEvent("page_view");
  fb.firebase.analytics().logEvent("screen_view", {
    app_name: isPWA() ? "pwa" : "web",
    screen_name: to.path,
    app_version: version
  });

  /**
   * TODO get feeds url then call API before page load and setup meta tags
   */

  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);

  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

  if (!nearestWithMeta) return next();

  nearestWithMeta.meta.metaTags.map(tagDef => {
    const tag = document.createElement('meta');

    Object.keys(tagDef).forEach(key => {
      tag.setAttribute(key, tagDef[key]);
    });

    tag.setAttribute('data-vue-router-controlled', '');

    return tag;
  })
    .forEach(tag => document.head.appendChild(tag));

  next();
})